export default __webpack_public_path__ + "static/media/Marcello_Role_Excerpts.9020c6e8.mp3";